import type { FC } from 'react'

interface IProps {
  colored?: boolean
  href?: string
  icon: JSX.Element
  name: string
  address: string
}

const ContactCard: FC<IProps> = ({ href, name, icon, address, colored }) => {
  return (
    <li className="min-w-[300px] flex-1">
      <a
        aria-label={name}
        href={href ? href : '#'}
        className={`flex flex-row items-center gap-4 rounded-xl border duration-200 ${
          colored
            ? 'border-primary bg-primary-light bg-primary/10'
            : 'border-secondary-light bg-white hover:border-primary'
        }  p-6`}
      >
        <span>
          <span
            className={`flex items-center justify-center overflow-hidden rounded-full border  ${
              colored
                ? href?.includes('hh.ru')
                  ? 'border-red-500 bg-red-500 text-[42px] text-white'
                  : 'h-[42px] w-[42px] border-primary bg-primary text-white '
                : 'h-[42px] w-[42px] border-secondary-light text-primary'
            }`}
          >
            {icon}
          </span>
        </span>
        <span className="flex flex-col gap-[6px]">
          {name ? (
            <span className="text-sm font-medium leading-[1] text-secondary">{name}</span>
          ) : null}
          <span className=" text-lg font-semibold leading-[1] text-secondary-darkest">
            {address}
          </span>
        </span>
      </a>
    </li>
  )
}

export default ContactCard
